import { Component, EventEmitter, Output, Input } from '@angular/core';
import { BreadcrumbModel, QueovalParam, BObjectModel, DynamicGroup, BreadDik, AgendaModel, AgendaEvent, SelectAgendaEvent, QueovalDateTime } from '../../models';
import { ToastService } from '../../toast';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import { AgendaQueovalService } from './../agenda.queoval.services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild } from '@angular/core';
import { AffichePlanningComponent } from './planning/affiche.planning.component';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-agenda-affiche',
  templateUrl: './affiche.component.html',
  styleUrls: ['./affiche.component.css']
})
// Affiche la grille du calendrier
export class AfficheComponent {

  public boolDataNeedToBeUpdated: boolean;
  public selectedDate: QueovalDateTime;
  public calendarOwnerIdSelected: string;
  public calendarObjectIdSelected: string;
  public calendarOfficeIdSelected: string;
  public calendarGroupIdSelected: string;
  public iCalendar: number;
  public enlargeContainer: boolean = false;
  @Input() LoadInfos: boolean
  @Input() model: AgendaModel;
  @Input() refreshData: boolean;
  @Input('enlargeContainer')
  set OnEnlargeContainer(value: boolean) {
    this.enlargeContainer = value;
  }
  @Output('modelChange') modelChange: EventEmitter<AgendaModel> = new EventEmitter<AgendaModel>(true);
  @Output('refreshDataChange') refreshDataChange: EventEmitter<boolean> = new EventEmitter<boolean>(true);
  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>(true);
  @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  @ViewChild('Planning') planningComponent: AffichePlanningComponent;

  constructor(
    private http: HttpService,
    protected toastService: ToastService,
    protected indParam: CoreService,
    private httpService: HttpService,
    protected qdate: QueovalDateService,
    private service: AgendaQueovalService,
    private modalService: NgbModal
  ) { }

  public SetRefreshData(refresh: boolean): void {
    this.refreshDataChange.emit(refresh);
  }

  public ModelChange(value: AgendaModel): void {
    this.model = value;
    this.modelChange.emit(this.model);
  }


  public EmitLoading(value: boolean): void {
    this.loading.emit(value);
  }


  // #region Useless méthodes

  public OpenModal(date: QueovalDateTime, content: any, iCalendar: number): void {
    this.selectedDate = date;
    this.calendarOwnerIdSelected = this.model.listCalendars[iCalendar].calendarOwnerId;
    this.calendarObjectIdSelected = this.model.listCalendars[iCalendar].calendarOBjectId;
    this.calendarOfficeIdSelected = this.model.listCalendars[iCalendar].calendarOfficeId;
    this.calendarGroupIdSelected = this.model.listCalendars[iCalendar].calendarGroupId;
    this.iCalendar = iCalendar;

    if (this.model.listCalendars[iCalendar].selectEvents.findIndex(e => e.isCreatable) > -1) {
      this.modalService.open(content, { backdrop: 'static', windowClass: 'qmodalover', centered: true });
    } else {
      this.toastService.showInfoToast('Vous ne disposez pas de droits suffisants pour ajouter un événement dans cet agenda.')
    }
  }

  public NewEvent(select: SelectAgendaEvent) {


    const clientData: string = `${this.selectedDate.jour}/${this.selectedDate.mois}/${this.selectedDate.annee}/${Number.parseInt(this.selectedDate.heures) < 10 ? '0' + this.selectedDate.heures : this.selectedDate.heures}`;
    this.http.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_ACCESS_RIGHTS/${this.calendarOwnerIdSelected}|${select.code}|${this.calendarObjectIdSelected}|${this.calendarOfficeIdSelected}|${this.model.GroupMode}/`).subscribe(
      (result: AgendaModel) => {
        if (result && result.selectedEvent && result.selectedEvent.pEvent) {
          const event = result.selectedEvent.pEvent;
          switch (select.code) {
            case 'REL_BO_OBJET_BO_RESERV':
              event.pere = this.calendarObjectIdSelected;
              break;
            case 'REL_BO_BUREAU_BO_RESERV':
              event.pere = this.calendarOfficeIdSelected;
              break;
            default:
              if (select.GroupMode) {
                event.pere = this.calendarGroupIdSelected;
                event.GroupMode = select.GroupMode;
              } else {
                event.pere = this.calendarOwnerIdSelected;
              }
              break;
          }
          event.code_DOR = select.code;
          event.relation = select.idRelation;
          event.ident = "0";
          event.type = select.type;
          this.RedirectEvent(event, clientData);
        }
      });

  }

  public GetInfoEvent(event: AgendaEvent): void {
    if (!event.isAnonimized) {
      event.GroupMode
      this.http.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_INFO/${event.ident}|${event.type}|${event.idPersonne}|${event.code_DOR}`).subscribe(
        () => {
        });
    }
  }
  public OpenEvent(event: AgendaEvent): void {
    const clientData: string = `${event.startDate.jour}/${event.startDate.mois}/${event.startDate.annee}/${Number.parseInt(event.startDate.heures) < 10 ? '0' + event.startDate.heures : event.startDate.heures}`;
    this.RedirectEvent(event, clientData)
  }

  private RedirectEvent(event: AgendaEvent, clientData: string) {
    const params: Array<BreadDik> = new Array<BreadDik>();
    const boModel: BObjectModel = new BObjectModel();
    boModel.ShowRemoveButton = event.isDeletable;
    boModel.ShowRemoveButton = event.isDeletable;
    boModel.ShowSaveButton = event.isUpdatable;
    boModel.IdDonneePere = event.pere;
    boModel.IdDonneeFils = event.ident;
    boModel.IdRelation = event.relation;
    boModel.CodeRelation = event.code_DOR;
    boModel.ClientData = new DynamicGroup();
    if (clientData) {
      boModel.ClientData.Date = clientData;
    }
    boModel.Mode = "CREATE";


    let param: QueovalParam = { params, model: boModel };
    let breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('add', '', param, '', true);

    switch (event.type) {
      case 'Reservation':
        if (boModel.CodeRelation !== 'REL_BO_CNX_BO_RESERV' && boModel.CodeRelation !== 'REL_BO_OBJET_BO_RESERV' && boModel.CodeRelation !== 'REL_BO_BUREAU_BO_RESERV') {
          this.toastService.showWarningToast(`Relation incorect ${boModel.CodeRelation}`);
        } else {
          params.push(new BreadDik('code', 'RESA'));
          if (event.GroupMode) {
            switch (event.GroupMode) {
              case 'CUSTOMER':
                boModel.IdDonneePere = `${this.indParam.AppParams.LoggedUser.Ident}`;
                params.push(new BreadDik('clientId', event.pere));
                params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
                break;
              case 'TRAINEES':

                break;
              case 'PROVIDER':
                params.push(new BreadDik('userId', event.pere));
                break;
              case 'TRAINING':
                params.push(new BreadDik('trainingId', event.pere));
                boModel.CodeRelation = 'REL_BO_STAGE_BO_RESERV';
                boModel.IdRelation = 'REL_BO_STAGE_BO_RESERV';
                params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
                break;
            }


          } else {
            switch (event.code_DOR) {
              case 'REL_BO_OBJET_BO_RESERV':
                event.code_DOR = 'REL_BO_CNX_BO_RESERV';
                boModel.CodeRelation = 'REL_BO_CNX_BO_RESERV'
                boModel.IdDonneePere = `${this.indParam.AppParams.LoggedUser.Ident}`;
                params.push(new BreadDik('objectId', event.pere));
                params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
                break;
              case 'REL_BO_BUREAU_BO_RESERV':
                event.code_DOR = 'REL_BO_CNX_BO_RESERV';
                boModel.CodeRelation = 'REL_BO_CNX_BO_RESERV'
                boModel.IdDonneePere = `${this.indParam.AppParams.LoggedUser.Ident}`;
                params.push(new BreadDik('officeId', event.pere));
                params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
                break;
              default:
                params.push(new BreadDik('userId', event.pere));
                break;
            }
          }
          param = { params, model: boModel };
          (param.model as BObjectModel).ShowZoomButton = false;
          breadCrumbItem = new BreadcrumbModel('add', 'reservation', param, 'Réservation', true);
        }
        break;

      case 'ReservationStagiaire':
        params.push(new BreadDik('code', 'RESASTG'));
        params.push(new BreadDik('userId', event.pere));
        param = { params, model: boModel };
        (param.model as BObjectModel).ShowZoomButton = false;
        breadCrumbItem = new BreadcrumbModel('add', 'reservationstagiaire', param, 'Réservation-apprenant', true);
        break;

      case 'ReservationFormateur':
        params.push(new BreadDik('code', 'RESAFORM'));
        if (event.GroupMode) {
          switch (event.GroupMode) {
            case 'CUSTOMER':
              params.push(new BreadDik('clientId', event.pere));
              boModel.IdDonneePere = `${this.indParam.AppParams.LoggedUser.Ident}`;
              params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
              break;
            case 'TRAINING':
              params.push(new BreadDik('trainingId', event.pere));
              boModel.CodeRelation = 'REL_BO_STAGE_BO_RESERV';
              boModel.IdRelation = 'REL_BO_STAGE_BO_RESERV';
              params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
              break;
            case 'PROVIDER':
              params.push(new BreadDik('userId', event.pere));
              break;
          }

        } else {
          params.push(new BreadDik('userId', event.pere));
        }
        param = { params, model: boModel };
        (param.model as BObjectModel).ShowZoomButton = false;
        breadCrumbItem = new BreadcrumbModel('add', 'reservationformateur', param, 'Réservation-formateur', true);
        break;

      case 'RendezVous':
        params.push(new BreadDik('code', 'RDV'));
        if (event.GroupMode) {
          boModel.IdDonneePere = `${this.indParam.AppParams.LoggedUser.Ident}`;
          params.push(new BreadDik('clientId', event.pere));
          params.push(new BreadDik('userId', this.indParam.AppParams.LoggedUser.Ident));
        } else {
          params.push(new BreadDik('userId', event.pere));
        }
        param = { params, model: boModel };
        breadCrumbItem = new BreadcrumbModel('add', 'rendezvous', param, 'Rendez-vous', true);
        break;

      case 'Conges':
        let strdt: string = '';
        if (clientData) {
          const dt: Array<string> = clientData.split('/');

          if (dt.length >= 3) {
            strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%2000:00&`;
          }
        }
        params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}RH/PageConge.aspx?${strdt}Collaborateur=${boModel.IdDonneePere}`));

        param = { params, model: boModel };
        breadCrumbItem = new BreadcrumbModel('add', 'conges', param, 'Congés', false);
        break;

      case 'Taches':
        if (!boModel.IdDonneeFils || boModel.IdDonneeFils === "0") {
          let strdt: string = '';
          if (clientData) {
            const dt: Array<string> = clientData.split('/');
            if (dt.length >= 4) {
              strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%20${dt[3]}:00&`;
            }
          }
          params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}SPEF_COMPTA/PageCreateTacheAffaire.aspx?P1=0&${strdt}IdUser=${boModel.IdDonneePere}`));

        } else {
          params.push(new BreadDik('code', 'TACHES'));
        }
        param = { params, model: boModel };
        breadCrumbItem = new BreadcrumbModel('add', 'taches', param, 'Taches', false);
        break;

      case 'Obligations':
        if (clientData) {
          if (!event.ident || event.ident === "0") {
            params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}SPEF_COMPTA/PageCreateObligation.aspx`));
            param = { params, model: boModel };
            breadCrumbItem = new BreadcrumbModel('add', 'taches', param, 'Obligations', false);
            this.sendBreadcrumb.emit(breadCrumbItem);
          } else {
            const dt: Array<string> = clientData.split('/');
            let strmois: string = `${dt[1]}`;
            this.httpService.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_CLIENT_BY_ID_OBLIGATION/${boModel.IdDonneeFils}`).subscribe((result: AgendaModel) => {
              if (result.Mode) {
                params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}SPEF_COMPTA/PageSaisiTempsPipe.aspx?REFRESH=0&IDUSER=${boModel.IdDonneePere}&IDDONNEE=${result.Mode}&IDOBLI=${boModel.IdDonneeFils}&IDMOIS=${strmois}`));
                param = { params, model: boModel };
                breadCrumbItem = new BreadcrumbModel('add', 'taches', param, 'Obligations', false);
                this.sendBreadcrumb.emit(breadCrumbItem);
              }
            });
          }
        }
        break;

      case 'ActionsCo':
        this.httpService.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/GET_ACTION_CO_MODE/0`).subscribe((result: AgendaModel) => {
          if (result.Mode === 'ASPX') {
            params.push(new BreadDik('Version', 'ASPX'));
            params.push(new BreadDik('code', 'ACTION_CO'));
            if (!boModel.IdDonneeFils || boModel.IdDonneeFils === "0") {
              let strdt: string = '';
              let strIdPersonne: string = '';
              if (clientData) {
                const dt: Array<string> = clientData.split('/');
                if (dt.length >= 5) {
                  strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%20${dt[3]}:${dt[4]}&`;
                } else if (dt.length >= 4) {
                  strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%20${dt[3]}:00&`;
                } else if (dt.length >= 3) {
                  strdt = `Date=${dt[0]}/${dt[1]}/${dt[2]}%2000:00&`;
                }
              }
              if (boModel.IdDonneePere) {
                strIdPersonne = `IdDonnee=${boModel.IdDonneePere}&`;
              }
              params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}GRC/PageNewAction.aspx?${strdt}${strIdPersonne}IDCLIENT=`));
            } else {
              params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}GRC/PageAction.aspx?IDDONNEE=${boModel.IdDonneeFils}`));
            }
            param = { params, model: boModel };
            breadCrumbItem = new BreadcrumbModel('add', 'actionCo', param, 'Action Commerciale', false);
          }
          else {
            params.push(new BreadDik('Version', 'ANGULAR'));
            params.push(new BreadDik('code', 'ACTION_CO'));
            if (!boModel.IdDonneeFils || boModel.IdDonneeFils === "0") {
              let qDt: QueovalDateTime = new QueovalDateTime();
              let strIdPersonne: string = '0';
              if (clientData) {
                const dt: Array<string> = clientData.split('/');
                if (dt.length >= 5) {
                  qDt = new QueovalDateTime(dt[2], dt[1], dt[0], dt[3], dt[4]);
                } else if (dt.length >= 4) {
                  qDt = new QueovalDateTime(dt[2], dt[1], dt[0], dt[3], '00');
                } else if (dt.length >= 3) {
                  qDt = new QueovalDateTime(dt[2], dt[1], dt[0], '00', '00');
                }
              }
              if (boModel.IdDonneePere) {
                strIdPersonne = boModel.IdDonneePere;
              }
              params.push(new BreadDik('IdDonnee', strIdPersonne));
              params.push(new BreadDik('Date', qDt));

            } else {
              params.push(new BreadDik('idActionCo', boModel.IdDonneeFils));
            }
            param = { params, model: boModel };
            breadCrumbItem = new BreadcrumbModel('add', 'actionCo', param, 'Action Commerciale', false);
          }
          this.sendBreadcrumb.emit(breadCrumbItem);
        });
        break;

      case 'PostIt':
        //let strdtPostIt: string = '';
        //if (clientData) {
        //  const dt: Array<string> = clientData.split('/');

        //  if (dt.length >= 3) {
        //    strdtPostIt = `&Date=${dt[0]}/${dt[1]}/${dt[2]}%2000:00`;
        //  }
        //}
        //params.push(new BreadDik('src', `${this.indParam.AppParams.appUrl}PageDonnee.aspx?FILE=POSTIT&P2=${boModel.IdDonneePere}${strdtPostIt}`));

        param = { params, model: boModel };
        breadCrumbItem = new BreadcrumbModel('add', 'postit', param, 'Post It', false);
        break;

      default:
        params.push(new BreadDik('userId', event.pere));
        param = { params, model: boModel };
        breadCrumbItem = new BreadcrumbModel('add', 'rendezvousformateur', param, 'Rendez-vous', true);
        break;
    }
    // this calls agenda.component.ts "getBreadcrumb" method (line 176)
    if (event.type !== 'Obligations' && event.type !== 'ActionsCo') {
      this.sendBreadcrumb.emit(breadCrumbItem);
    }
  }
  // #endregion
}
